import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api, { setSessionToken } from "@/lib/api";
import BrandMark from "@/components/BrandMark";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser, refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        if (data.session_token) setSessionToken(data.session_token);
        setUser({
          user_id: data.user_id,
          email: data.email,
          name: data.name,
          picture: data.picture,
          onboarded: data.onboarded,
          terms_accepted_at: data.terms_accepted_at,
        });
        // Ensure AuthContext is populated with the authoritative /auth/me snapshot
        // before we hand off to ProtectedRoute (belt-and-suspenders against stale state).
        try {
          await refresh();
        } catch (refreshErr) {
          console.warn("auth refresh after login failed", refreshErr);
        }
        // Route decision matches ProtectedRoute logic: consent → onboarding → home.
        if (!data.terms_accepted_at) {
          navigate("/consent", { replace: true });
        } else if (!data.onboarded) {
          navigate("/onboarding", { replace: true });
        } else {
          navigate("/home", { replace: true });
        }
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FBF9F6] gap-8">
      <BrandMark variant="center" />
      <div className="text-stone-500 font-[Manrope] text-sm tracking-wider uppercase">Signing you in…</div>
    </div>
  );
}
